module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"917.561\" height=\"894.44\" viewBox=\"62.584 127.157 917.561 894.44\"><path d=\"M977.498 434.065a32 32 0 0 0-29.286-19.26l-270.365-.568L554.223 145.85a32 32 0 0 0-29.102-18.693h-.262a32.004 32.004 0 0 0-29.054 19.17L377.69 414.237l-283.17.57a31.994 31.994 0 0 0-29.484 19.716 32.004 32.004 0 0 0 6.82 34.81L293.54 692.995l-66.818 289.402a32 32 0 0 0 47.622 34.652l250.97-150.31 257.306 150.48c10.96 6.41 24.675 5.73 34.95-1.728s15.17-20.29 12.473-32.696l-63.86-293.61L971.57 468.612a32 32 0 0 0 5.93-34.545z\"/></svg>"


/*****************
 ** WEBPACK FOOTER
 ** ./~/seek-style-guide/react/icons/StarIcon/StarIconFilled.svg
 ** module id = 653
 ** module chunks = 0
 **/